module.exports = __webpack_public_path__ + "img/lotteries.17cda350.png";